<template>
  <cta
    :text="text"
    variant="solid"
    color="red"
    :show-icon="true"
    :href="href"
    :anchor="anchor"
    @click="$emit('click')"
    @mouseenter=" isHovered = true; "
    @mouseleave=" isHovered = false; ">
    <template #icon>
      <div class="icon-wrapper">
        <slot
          v-if="!isHovered"
          name="icon" />
        <slot
          v-else
          name="icon-hover" />
      </div>
    </template>
  </cta>
</template>

<script setup>
  import Cta from '~/components/Cta.vue'

  const isHovered = ref(false)

  defineProps({
    text: {
      type: String,
      required: true
    },
    colorChange: {
      type: Boolean,
      required: false,
      default: false
    },
    href: {
      type: String,
      default: null
    },
    anchor: {
      type: Boolean,
      default: false
    }
  })

  defineEmits([ 'click' ])
</script>

<style lang="scss" scoped>
.icon-wrapper {
  height: 18px;
  width: 26px;
  position: relative;
}

.icon-wrapper * {
  position: absolute;
  left: 0;
  top: -25%;
}
</style>
